<div *ngIf="state === states.error" [@openClose]>
	<atomic-message-bar class="my-10">
		Unable to fetch details from TitlePLUS. Please try logging in again
	</atomic-message-bar>
	<app-button
		(click)="goToTitlePlus()"
		[testHook]="testHooks.GoBackToIntegrationPageButton"
		>Go back to integration page</app-button
	>
</div>

<div
	*ngIf="state === states.saving"
	class="flex flex-col justify-center items-center"
>
	<div class="w-52 mb-10">
		<img src="assets/images/integrations/title-plus-logo.svg" />
	</div>
	<div class="flex gap-4">
		<app-icon [spin]="true" [icon]="ICON.LOADING"></app-icon>
		<p>Storing auth credentials</p>
	</div>
</div>

<ng-template #successDialogTemplate>
	<div class="flex flex-col gap-8 p-16">
		<div class="h-20">
			<img
				class="h-full w-auto"
				src="/assets/images/closer-logos/closer-logo-full.png"
				alt="Closer logo"
			/>
		</div>
		<div class="h-80 flex justify-center">
			<img
				class="h-full w-auto"
				src="/assets/images/integrations/title-plus-connect-success.png"
				alt="TitlePlus connection successful"
			/>
		</div>
		<div class="flex flex-col items-center">
			<h1 class="text-3xl font-medium mb-4">TitlePLUS Information Connected</h1>
			<p class="text-base font-normal">
				Please close this browser window and return to the previous window.
			</p>
		</div>
	</div>
</ng-template>
